import validator from 'validator'
import without from 'lodash/without'
import get from 'lodash/get'
import includes from 'lodash/includes'
import moment from 'moment'
import statesAndProvinces from '../locations/statesAndProvinces'

const isRequired = param => (param ? null : 'Required')

const isAnEmail = param => (param && validator.isEmail(param) ? null : 'Invalid email')

const isAPhone = param => (/^[+\d\-()]{7,}$/.test(param) ? null : 'Invalid phone number')

const isAYear = param => (/^\d{4}$/.test(param) ? null : 'Invalid year')

const isUS = param => param === 'USA'

const isCN = param => param === 'CN'

const isAUSState = param =>
  includes(get(statesAndProvinces, 'americanStates'), param) ? null : 'Invalid US State'

const isACNProvince = param =>
  includes(get(statesAndProvinces, 'canadianProvinces'), param) ? null : 'Invalid Canadian Province'

const isValidBirthDate = param => {
  if (!param) return 'Required'

  if (moment(param).isAfter(moment())) return 'Birth date cannot be in the future'

  if (moment().diff(param, 'years') < 13) return 'You must be at least 13 years old to register'

  return null
}

const isValidPassword = param => {
  const pattern = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/
  if (!param) return 'Required'
  if (pattern.test(param)) {
    return null
  } else {
    return 'Password must be at least 8 characters long and contain at least one letter, one number, and one special character.'
  }
}

const hasASelectedValue = param => {
  if (!param) {
    return 'Required'
  }
  const keys = Object.keys(param)
  const withoutAll = without(keys, 'all')
  if (!withoutAll.length) {
    return 'Required'
  }
  return null
}

const isAfter = (value, controlDate) => {
  return moment(value).isAfter(controlDate)
    ? null
    : `Must be after ${moment(controlDate).format('MM/DD/YYYY')}`
}

const maxLengthTwoHundred = param => {
  let result = null
  if (typeof param === 'string' && !validator.isLength(param, { max: 200 })) {
    result = 'Must be 200 characters or less'
  }

  return result
}

export default {
  hasASelectedValue,
  isRequired,
  isAnEmail,
  isAPhone,
  isAYear,
  isUS,
  isCN,
  isAUSState,
  isACNProvince,
  isAfter,
  isValidBirthDate,
  isValidPassword,
  maxLengthTwoHundred,
}



// WEBPACK FOOTER //
// ./src/utils/validation/formValidators.js